import React, { useEffect, useState } from "react";
import ConfigData from "../../master/components/ConfigData";
import { Checkbox, Button, Grid, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TableSortLabel, } from "@material-ui/core";
import { EmptyCollection, ExportMenu, FilterComponent, Pagination, ImportMenu, DeletePopUp, PageLoader, STableLoader, RevisionHistory } from "../../../shared_elements";
import { globalDeleteService, globalExportService, globalGetService, globalPostService, globalPutService } from "../../../../globalServices";
import { checkApiStatus ,checkPermission} from "../../../utils_v2";
import { Link, withRouter } from 'react-router';
import EngineTypesList from "../components/EngineTypesList";
import AddEditEngineTypes from "../components/AddEditEngineTypes";
import { trackActivity } from "../../../../utils/mixpanel";
import { useSnackbar } from "notistack";
import AddIcon from '@material-ui/icons/Add';
import LinkingPopup from "../../../shared_elements/LinkingPopup";
import { engineTypeFilter } from "..";
import NoAccess from "../../aircraftModels/components/NoAccess";
import { usePageTitleOffset } from '../../../elements/CollapsibleSideNav';

const EngineTypeObj = {
    name: null,
    aircraft_type: [],
    aircraft_body_type: null,
    engine_family: null,
    svc_escalation: null,
    svc_interval: null,
    low_escalation: null,
    low_interval: null,
    remarks: null
}

const EngineTypesHeader = ({ isEngine, handleSelectAll, isSelectAllChecked, createSortHandler, sortInfo, deleted }) => {
    return (
        <TableHead>
            <TableRow >
                {!deleted ? <TableCell style={{ position: 'sticky', left: 0, backgroundColor: '#B5BEDB', zIndex: 10, }} ><div style={{ width: '130px' }}>{checkPermission('config_data', 'engine_types', 'D') &&<Checkbox checked={isSelectAllChecked} onChange={handleSelectAll} color="primary" size="small" />}Action(s)</div></TableCell> : null}
                <TableCell>
                    <div style={{ width: '130px' }}>
                        {!isEngine ?<TableSortLabel
                            active={sortInfo.sort === 'name' ? true : false}
                            direction={sortInfo.sort === 'name' ? sortInfo.sort_by : 'asc'}
                            onClick={() => createSortHandler('name')}
                        >
                            Name
                        </TableSortLabel> : "Name"}
                    </div>
                </TableCell>
                <TableCell>
                    <div style={{ width: '120px' }}>
                        {!isEngine ? <TableSortLabel
                            active={sortInfo.sort === 'engine_family' ? true : false}
                            direction={sortInfo.sort === 'engine_family' ? sortInfo.sort_by : 'asc'}
                            onClick={() => createSortHandler('engine_family')}
                        >
                            Engine Family
                        </TableSortLabel> : "Engine Family" }
                    </div>
                </TableCell>
                <TableCell >
                    <div style={{ width: '150px' }}>
                        {!isEngine ? <TableSortLabel
                            active={sortInfo.sort === 'aircraft_body_type' ? true : false}
                            direction={sortInfo.sort === 'aircraft_body_type' ? sortInfo.sort_by : 'asc'}
                            onClick={() => createSortHandler('aircraft_body_type')}
                        >
                            Aircraft Body Type
                        </TableSortLabel> : "Aircraft Body Type" }
                    </div>
                </TableCell>
                <TableCell><div style={{ width: '150px' }}>Aircraft Type</div></TableCell>
                <TableCell>
                    <div style={{ width: '150px' }}>
                        {!isEngine ? <TableSortLabel
                            active={sortInfo.sort === 'svc_escalation' ? true : false}
                            direction={sortInfo.sort === 'svc_escalation' ? sortInfo.sort_by : 'asc'}
                            onClick={() => createSortHandler('svc_escalation')}
                        >
                            SVC Esc(%)
                        </TableSortLabel> : "SVC Esc(%)"}
                    </div>
                </TableCell>
                <TableCell >
                    <div style={{ width: '150px' }}>
                        {!isEngine ? <TableSortLabel
                            active={sortInfo.sort === 'svc_interval' ? true : false}
                            direction={sortInfo.sort === 'svc_interval' ? sortInfo.sort_by : 'asc'}
                            onClick={() => createSortHandler('svc_interval')}
                        >
                            SVC Interval
                        </TableSortLabel> : "SVC Interval" }
                    </div>
                </TableCell>
                <TableCell >
                    <div style={{ width: '150px' }}>
                        {!isEngine ? <TableSortLabel
                            active={sortInfo.sort === 'low_escalation' ? true : false}
                            direction={sortInfo.sort === 'low_escalation' ? sortInfo.sort_by : 'asc'}
                            onClick={() => createSortHandler('low_escalation')}
                        >
                            LOW Esc(%)
                        </TableSortLabel> : "LOW Esc(%)" }
                    </div>
                </TableCell>
                <TableCell >
                    <div style={{ width: '150px' }}>
                        {!isEngine ? <TableSortLabel
                            active={sortInfo.sort === 'low_interval' ? true : false}
                            direction={sortInfo.sort === 'low_interval' ? sortInfo.sort_by : 'asc'}
                            onClick={() => createSortHandler('low_interval')}
                        >
                            LOW Interval
                        </TableSortLabel> : "LOW Interval" }
                    </div>
                </TableCell>
                <TableCell >
                    <div style={{ width: '150px' }}>
                        {!isEngine ? <TableSortLabel
                            active={sortInfo.sort === 'thrust' ? true : false}
                            direction={sortInfo.sort === 'thrust' ? sortInfo.sort_by : 'asc'}
                            onClick={() => createSortHandler('thrust')}
                        >
                            Thrust
                        </TableSortLabel> : "Thrust" }
                    </div>
                </TableCell>
                <TableCell >
                    <div style={{ width: '140px' }}>
                        {!isEngine ? <TableSortLabel
                            active={sortInfo.sort === 'created_by' ? true : false}
                            direction={sortInfo.sort === 'created_by' ? sortInfo.sort_by : 'asc'}
                            onClick={() => createSortHandler('created_by')}
                        >
                            Created By
                        </TableSortLabel> : "Created By" }
                    </div>
                </TableCell>
                <TableCell >
                    <div style={{ width: '150px' }}>
                        {!isEngine ? <TableSortLabel
                            active={sortInfo.sort === 'updated_by' ? true : false}
                            direction={sortInfo.sort === 'updated_by' ? sortInfo.sort_by : 'asc'}
                            onClick={() => createSortHandler('updated_by')}
                        >
                            Last Updated By
                        </TableSortLabel> : "Last Updated By" }
                    </div>
                </TableCell>
                <TableCell >
                    <div style={{ minWidth: '150px' }}>
                        {!isEngine ? <TableSortLabel
                            active={sortInfo.sort === 'remarks' ? true : false}
                            direction={sortInfo.sort === 'remarks' ? sortInfo.sort_by : 'asc'}
                            onClick={() => createSortHandler('remarks')}
                        >
                            Remarks
                        </TableSortLabel> : "Remarks" }
                    </div>
                </TableCell>
            </TableRow>
        </TableHead >
    )
}

const EngineTypes = ({ params, isEngine, deleted, aircraftTypeName }) => {
    const navTitleOffset = usePageTitleOffset('configDataNavCollapsed');
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const [isLoading, setLoading] = useState(false);
    const [filter, setFilter] = useState({});
    const [pageSelections, setPageSelections] = useState({});
    const [currentPage, setCurrentPage] = useState({});
    const [skeletonLoader, setSkeletonLoader] = useState(false);
    const [sortInfo, setSortInfo] = useState({ sort: '', sort_by: '' });
    const [bulkDelete, setBulkDelete] = useState({ modal: false, data: null })
    const [bulkRevert, setBulkRevert] = useState({ modal: false, data: null })
    const [bulkUnlink, setBulkUnLink] = useState({ modal: false, data: null })
    const [deleteEngineTypes, setDeleteEngineTypes] = useState({ modal: false, data: null });
    const [unLinkEngineTypes, setUnLinkEngineTypes] = useState({ modal: false, data: null });
    const [revertEngineTypes, setRevertEngineTypes] = useState({ modal: false, data: null });
    const [addEditEngineTypes, setAddEditEngineTypes] = useState({ modal: false, data: null, type: '' });
    const [engineTypesInfo, setEngineTypesInfo] = useState({ list: [], pagination: {} });
    const [linkingEngine, setLinkingEngine] = useState({ modal: false, data: null })
    const [circularLoader, setCircularloader] = useState(false)
    const [enginefamilyFilter, setEnginefamilyFilter] = useState([]);
    const [filterAircraftTypes, setFilterAircraftTypes] = useState([]);
    const [acBodyTypeFilter, setAcBodyTypeFilter] = useState([])

    useEffect(() => {
        getEngineTypes({ per_page: 50 }, !isEngine ? "skeletonLoader" : 'pageLoader');
        trackActivity('Console Management', { page_title: !isEngine ? 'Config Data : Engine Types' : 'Config Data : Aircraft Types View page', event_type: !isEngine ? 'Page Visited' : 'Engine Type Tab Clicked' })
        getEngineFamily();
        getAcBodyType();
        getAircraftTypes();
    }, [])

    const getEngineTypes = (query = {}, loaderType) => {
        loaderType === 'skeletonLoader' ? setSkeletonLoader(true) : setLoading(true)

        const url = !isEngine ? `config-data/engine-type/` : `config-data/aircraft-type/?linked_aircraft_types_name=engine_type&id=${params?.id}&action=link`;

        globalGetService(url, query)
            .then(response => {
                if (checkApiStatus(response)) {
                    setEngineTypesInfo(response.data.data)
                    if(query){
                        delete query.page
                        delete query.per_page
                        delete query.sort
                        delete query.sort_by
                        setFilter(query)
                    }
                }
                loaderType === 'skeletonLoader' ? setSkeletonLoader(false) : setLoading(false)
            })
    }

    const toggleBulkOps = (item, checked, currentPage) => {
        setPageSelections(prevSelections => {
            const updatedSelections = { ...prevSelections };
            if (checked) {
                updatedSelections[currentPage] = updatedSelections[currentPage] || [];
                updatedSelections[currentPage].push(item?.id);
            } else {
                updatedSelections[currentPage] = updatedSelections[currentPage]?.filter(id => id !== item?.id);
            }
            return updatedSelections;
        });
    };

    const linkUnlink = (type, ids) => {

        const idss = !unLinkEngineTypes.data ? Object.values(pageSelections).flat().filter(id => id) : [unLinkEngineTypes?.data?.id]
        let payload;
        if (type === 'link') {
            payload = {
                aircraft_type_id: params.id || null,
                linked_aircraft_types: "engine_type" || null,
                ids: ids || [],
            };
        } else {
            payload = {
                aircraft_type_id: params.id || null,
                linked_aircraft_types: "engine_type" || null,
                ids: idss || [],
                action: 'unlink'
            };
        }

        const apiUrl = `config-data/aircraft-type/`;
        setCircularloader(true);
        globalPostService(apiUrl, payload)
            .then((response) => {
                if (checkApiStatus(response)) {
                    enqueueSnackbar(response?.data?.message, { variant: 'success', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
                    toggleModalFn();
                    getEngineTypes();
                    setPageSelections({})
                    trackActivity('Console Management', {
                        event_desc: type === 'link' ? `Engine Types Linked Successfully` : 'Engine Types unLinked Successfully',
                        page_title: 'Config Data : Aircraft Types View Page',
                        event_type: type === 'link' ? 'Item Linked' : 'Item UnLinked',
                        updated_id: type === 'link' ? ids : idss || null,
                        success_msg: response?.data?.message,
                        data:JSON.stringify(payload)
                    })
                } else {
                    enqueueSnackbar(response?.data?.message, { variant: 'error', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
                    getEngineTypes();
                    toggleModalFn();
                    setPageSelections({})
                    trackActivity('Console Management', {
                        event_desc: type === 'link' ? 'Engine Types Linking Failed' : 'Engine Types Unlinking Failed',
                        page_title: 'Config Data : Aircraft Types View Page',
                        event_type: type === 'link' ? 'Item Linked' : 'Item UnLinked',
                        updated_id: type === 'link' ? ids : idss || null,
                        error_msg: response?.data?.message,
                        data:JSON.stringify(payload)
                    })
                }
                setCircularloader(false);
            })
    }


    const onDelete = () => {
        setLoading(true);
        const ids = !deleteEngineTypes.data ? Object.values(pageSelections).flat().filter(id => {
            const item = engineTypesInfo.list.find(item => item.id === id);
            return item && !item.deleted_at;
        }) : deleteEngineTypes.data.id

        globalDeleteService(`config-data/engine-type/bulk-delete/`, { ids })
            .then(response => {
                if (checkApiStatus(response)) {
                    setDeleteEngineTypes({ modal: false, data: null });
                    getEngineTypes({ ...filter, page: engineTypesInfo?.pagination?.page, per_page: engineTypesInfo?.pagination?.per_page }, 'pageLoader');
                    setLoading(false);
                    setCurrentPage({});
                    setBulkDelete({ modal: false, data: null })
                    setPageSelections({});
                    enqueueSnackbar(response?.data?.message, { variant: 'success', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
                    trackActivity('Console Management', {
                        page_title: 'Config Data : Engine Types',
                        event_type: `Item Deleted`,
                        event_desc: 'Engine Types Deleted Successfully',
                        success_msg: response?.data?.message,
                        deleted_id: ids
                    });
                } else {
                    setDeleteEngineTypes({ modal: false, data: null });
                    setLoading(false);
                    setBulkDelete({ modal: false, data: null })
                    setPageSelections({});
                    enqueueSnackbar(response?.data?.message, { variant: 'error', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
                    trackActivity('Console Management', {
                        page_title: 'Config Data : Engine Types',
                        event_type: `Item Deleted`,
                        event_desc: 'Engine Types Deletion Failed',
                        error_msg: response?.data?.message,
                        item_id: ids
                    });
                }
            });
    };

    const onRevert = () => {
        setLoading(true);
        const ids = !revertEngineTypes.data ? Object.values(pageSelections).flat().filter(id => {
            const item = engineTypesInfo.list.find(item => item.id === id);
            return item && item.deleted_at;
        }) : revertEngineTypes.data;

        globalPutService(`config-data/engine-type/restore/`, { ids })
            .then(response => {
                if (checkApiStatus(response)) {
                    setRevertEngineTypes({ modal: false, data: null });
                    getEngineTypes({ ...filter, page: engineTypesInfo?.pagination?.page, per_page: engineTypesInfo?.pagination?.per_page }, 'pageLoader');
                    setCurrentPage({});
                    setLoading(false)
                    setPageSelections({});
                    setBulkRevert({ modal: false, data: null })
                    enqueueSnackbar(response?.data?.message, { variant: 'success', anchorOrigin: { vertical: 'top', horizontal: 'right' } })
                    trackActivity('Console Management', {
                        page_title: 'Config Data : Engine Types',
                        event_type: `Item Reverted`,
                        event_desc: 'Engine Types Reverted Successfully',
                        success_msg: response?.data?.message,
                        reverted_id: ids
                    });
                } else {
                    setRevertEngineTypes({ modal: false, data: null });
                    setLoading(false);
                    setBulkRevert({ modal: false, data: null })
                    setPageSelections({});
                    enqueueSnackbar(response?.data?.message, { variant: 'error', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
                    trackActivity('Console Management', {
                        page_title: 'Config Data : Engine Types',
                        event_type: `Item Reverted`,
                        event_desc: 'Engine Types Reversion Failed',
                        error_msg: response?.data?.message,
                        item_id: ids
                    });
                }
            });
    };

    const handleSelectAll = (event, currentPage) => {
        if (event?.target.checked) {
            const allIds = engineTypesInfo?.list.map(item => item.id);
            setPageSelections(prevSelections => ({ ...prevSelections, [currentPage]: allIds }));
        } else {
            setPageSelections(prevSelections => ({ ...prevSelections, [currentPage]: [] }));
        }
    };

    const getFilteredSelectionCounts = () => {
        let deleteCount = 0;
        let revertCount = 0;

        if (pageSelections[currentPage]?.length) {
            pageSelections[currentPage].forEach(id => {
                const selectedItem = engineTypesInfo?.list?.find(item => item?.id === id);
                if (selectedItem) {
                    if (selectedItem?.deleted_at) {
                        revertCount++;
                    } else {
                        deleteCount++;
                    }
                }
            });
        }
        return { deleteCount, revertCount };
    };

    const { deleteCount, revertCount } = getFilteredSelectionCounts();

    const createSortHandler = (key) => {
        let sortQuery = { sort: key };
        if (sortInfo.sort === key) {
            sortQuery = { ...sortQuery, sort_by: sortInfo.sort_by === 'asc' ? 'desc' : 'asc' }
        } else {
            sortQuery = { ...sortQuery, sort_by: 'asc' }
        }
        setSortInfo(sortQuery)
        getEngineTypes({ ...filter, ...sortQuery, page: 1, per_page: engineTypesInfo?.pagination?.per_page || 20 }, 'pageLoader');
    }

    const isSelectAllChecked = engineTypesInfo?.list?.length > 0 && pageSelections[currentPage]?.length === engineTypesInfo?.list?.length;

    const getConfirmColor = () => {
        if (revertEngineTypes?.modal || bulkRevert?.modal) return "primary";
        if (deleteEngineTypes?.modal || bulkDelete?.modal) return "secondary";
        if (unLinkEngineTypes?.modal || bulkUnlink?.modal) return "secondary";
        return "";
    };

    const getConfirmText = () => {
        if (revertEngineTypes?.modal || bulkRevert?.modal) return "Revert";
        if (deleteEngineTypes?.modal || bulkDelete?.modal) return "DELETE";
        if (unLinkEngineTypes?.modal || bulkUnlink?.modal) return "UnLink"
        return "";
    };

    const getModal = () => {
        if (revertEngineTypes?.modal) return revertEngineTypes.modal;
        if (deleteEngineTypes?.modal) return deleteEngineTypes.modal;
        if (bulkDelete?.modal) return bulkDelete.modal;
        if (bulkRevert?.modal) return bulkRevert.modal;
        if (unLinkEngineTypes?.modal) return unLinkEngineTypes.modal;
        if (bulkUnlink?.modal) return bulkUnlink.modal;
        return null;
    };

    const getTitle = () => {
        if (revertEngineTypes?.modal) return "Revert Engine Types";
        if (deleteEngineTypes?.modal) return "Delete Engine Types";
        if (bulkDelete?.modal) return `Delete Engine Types (${deleteCount})`;
        if (bulkRevert?.modal) return `Revert Engine Types (${revertCount})`;
        if (unLinkEngineTypes?.modal) return "UnLink Engine Types";
        if (bulkUnlink?.modal) return `Unlink Engine Types (${deleteCount})`
        return "";
    };

    const getContent = () => {
        if (revertEngineTypes?.modal || bulkRevert?.modal)
            return "Are you sure, you want to Revert?";
        if (deleteEngineTypes?.modal || bulkDelete?.modal)
            return "Are you sure, you want to Delete?";
        if (unLinkEngineTypes?.modal || bulkUnlink?.modal)
            return "Are you sure, you want to UnLink"
        return "";
    };

    const toggleModalFn = () => {
        if (revertEngineTypes?.modal) {
            setRevertEngineTypes({ modal: false, data: null });
        } else if (deleteEngineTypes?.modal) {
            setDeleteEngineTypes({ modal: false, data: null });
        } else if (bulkDelete?.modal) {
            setBulkDelete({ modal: false, data: null });
        } else if (bulkRevert?.modal) {
            setBulkRevert({ modal: false, data: null });
        } else if (bulkUnlink?.modal) {
            setBulkUnLink({ modal: false, data: null });
        } else if (unLinkEngineTypes?.modal) {
            setUnLinkEngineTypes({ modal: false, data: null });
        } else {
            setLinkingEngine({ modal: false, data: null });
        }
    };


    const getDeleteRecordFn = () => {
        if (revertEngineTypes?.modal || bulkRevert?.modal) return onRevert;
        if (deleteEngineTypes?.modal || bulkDelete?.modal) return onDelete;
        if (unLinkEngineTypes?.modal || bulkUnlink?.modal) return linkUnlink || null;
        return null;
    };
    const getEngineFamily = () => {
            globalGetService(`config-data/engine-families/?lite=true`)
                .then(response => {
                    if (checkApiStatus(response)) {
                        let enginefamilyInfo = [];    
                        const data = response?.data?.data;
                        data.map((item) => {
                            enginefamilyInfo.push({ id: item?.id, name: item?.name });
                        });
                        setEnginefamilyFilter(enginefamilyInfo);
                    }
                })
        }
    const getAcBodyType = () => {
        globalGetService(`technical/blueprints/`)
            .then(response => {
                if (checkApiStatus(response)) {
                    let data = response.data.data.map(item => { return { label: item?.name, value: item?.id } })
                    setAcBodyTypeFilter(data)
                }
            })
    }
    const getAircraftTypes = () => {
        globalGetService(`config-data/aircraft-type/?lite=true`)
            .then(response => {
                if (checkApiStatus(response)) {
                    let aircraftTypeInfo = [];
                    const data = response?.data?.data;
                    data && data.map((item) => {
                        aircraftTypeInfo.push({ id: item?.id, name: item?.name })
                    });
                    setFilterAircraftTypes(aircraftTypeInfo);
                }
            })
    }     
    let filterOption = engineTypeFilter
    filterOption = {
        ...filterOption,
        engine_family: {
            ...filterOption.engine_family,
            options: enginefamilyFilter
        },
        aircraft_type: {
            ...filterOption.aircraft_type,
            options: filterAircraftTypes
        },
        aircraft_body_type: {
            ...filterOption.aircraft_body_type,
            options: acBodyTypeFilter
        },
    }

    return (

        <section className="asset-tech-specs" style={{ margin: isEngine ? '0px' : '25px 0 0 75px' }}>
            {checkPermission('config_data', 'engine_types', 'R') ?
                <Paper elevation={isEngine ? 0 : 1} className="tech-specs-card" style={{ height: isEngine ? `${window.innerHeight - 490}px` : `${window.innerHeight - 89}px` }}>
                    {!isEngine ? <ConfigData /> : null}
                    <div className="tech-specs-content" style={{ margin: isEngine ? "8px 0px 0px 0px" : '', paddingTop: '0px' }}>
                        {skeletonLoader ? <STableLoader count={6} size={9} /> :
                            <div style={{ padding: isEngine ? '0px' : '10px' }}>
                                <Paper elevation={0} className="console-paper" style={{ padding: '5px 10px', marginBottom: "2px" }}>
                                    <Grid container spacing={1} alignItems="center">
                                        <Grid item md={6}>
                                            {!isEngine ? <FilterComponent
                                                filter={filter}
                                                filterMenu={filterOption}
                                                getResponseBack={(applyFilter) => { getEngineTypes({ ...applyFilter, page: 1, per_page: engineTypesInfo?.pagination?.per_page || 10 }, 'pageLoader') }}
                                            /> : null}
                                        </Grid>
                                        <Grid item md={6}>
                                            {!isEngine ? <ul className='list-inline flex-centered' style={{ float: 'right' }}>
                                                {revertCount > 0 && (
                                                    <li className='list-inline-item'>
                                                        <Button onClick={() => { setBulkRevert({ modal: true, data: null }); trackActivity('Console Management', { page_title: 'Config Data : Engine Types', item_type: 'Bulk Revert', event_type: 'Modal Clicked', event_desc: `Clicked to open Bulk Revert Modal from Engine Types` }) }} color="primary" size='small' variant="outlined">
                                                            Revert ({revertCount})
                                                        </Button>
                                                    </li>
                                                )}
                                                {deleteCount > 0 && (
                                                    <li className='list-inline-item'>
                                                        <Button onClick={() => { setBulkDelete({ modal: true, data: null }); trackActivity('Console Management', { page_title: 'Config Data : Engine Types', item_type: 'Bulk Delete', event_type: 'Modal Clicked', event_desc: `Clicked to open Bulk Delete Modal from Engine Types` }) }} color="secondary" size='small' variant="contained">
                                                            Delete ({deleteCount})
                                                        </Button>
                                                    </li>
                                                )}
                                                {checkPermission('config_data', 'engine_types', 'C') && <li className='list-inline-item'>
                                                    <Button onClick={() => setAddEditEngineTypes({ modal: true, data: EngineTypeObj, type: 'add' })} color="primary" size='small' variant="contained"><AddIcon style={{ fontSize: '1.15rem' }} />ADD</Button>
                                                </li>}
                                                <li className='list-inline-item' style={{ cursor: 'pointer' }}>
                                                    <RevisionHistory isExp={false} buttonType={true} url={`audit/config-data/cdenginetypes/`} queryParams={{ action: '0,1,2' }} />
                                                </li>
                                            </ul> : !deleted ?
                                                <ul style={{ textAlign: "right" }}>
                                                    {deleteCount > 0 && checkPermission('config_data', 'engine_types', 'D') && (
                                                        <li className='list-inline-item'>
                                                            <Button onClick={() => { setBulkUnLink({ modal: true, data: null }); trackActivity('Console Management', { page_title: 'Config Data : Engine Types', item_type: 'Bulk Unlink', event_type: 'Modal Clicked', event_desc: `Clicked to open Bulk Unlink Engine Types to Aircraft Type` }) }} color="secondary" size='small' variant="contained">
                                                                Unlink ({deleteCount})
                                                            </Button>
                                                        </li>)}
                                                        {checkPermission('config_data', 'engine_types', 'U') &&  <li className='list-inline-item'>
                                                        <Button onClick={() => setLinkingEngine({ modal: true, data: engineTypesInfo })} color="primary" size='small' variant="contained">Link Engine Type</Button>
                                                    </li>}
                                                    <li className='list-inline-item' style={{ cursor: 'pointer', verticalAlign: 'middle' }}>
                                                        <RevisionHistory isExp={false} buttonType={true} url={`audit/config-data/cdenginetypes/`} queryParams={{ action: '0,1,2', linked_id: params?.id }} linkedName={aircraftTypeName} />
                                                    </li>
                                                </ul> : null}
                                        </Grid>
                                    </Grid>
                                </Paper>
                                <Paper square>
                                  <div style={{ height: isEngine ? `${(window.innerHeight - (engineTypesInfo?.list?.length ? 535:490)) - navTitleOffset}px` : `${(window.innerHeight - (engineTypesInfo?.list?.length ? 200 : 150)) - navTitleOffset}px`, overflow: 'auto' }}>
                                    <Table className="mui-table-format" stickyHeader>
                                        <EngineTypesHeader deleted={deleted} isSelectAllChecked={isSelectAllChecked} isEngine={isEngine} handleSelectAll={(e) => handleSelectAll(e, currentPage)} createSortHandler={createSortHandler} sortInfo={sortInfo} />
                                        <TableBody>
                                            {engineTypesInfo?.list?.length > 0 && engineTypesInfo?.list?.map((item, index) =>
                                                <EngineTypesList
                                                    linkedId={params?.id}
                                                    linkedName={aircraftTypeName}
                                                    isEngine={isEngine}
                                                    item={item}
                                                    deleted={deleted}
                                                    index={index}
                                                    unLink={setUnLinkEngineTypes}
                                                    onDelete={setDeleteEngineTypes}
                                                    onRevert={setRevertEngineTypes}
                                                    onEditFn={() => setAddEditEngineTypes({ modal: true, data: item, type: 'edit' })}
                                                    toggleBulkOps={(item, checked) => toggleBulkOps(item, checked, currentPage)}
                                                    bulkIds={pageSelections[currentPage] || []}
                                                />
                                            )}
                                        </TableBody>
                                    </Table>
                                       {!engineTypesInfo?.list?.length ? <div style={{ textAlign: 'center' }}><EmptyCollection title='No records found' /></div> : null}
                                     </div>
                                </Paper>
                                <Paper square>
                                    <Pagination
                                        pagination={engineTypesInfo?.pagination}
                                        onChangePage={(event, newPage) => { getEngineTypes({ ...filter, page: newPage + 1, per_page: engineTypesInfo.pagination?.per_page, sort_by: sortInfo?.sort_by, sort: sortInfo?.sort }, 'pageLoader'); setCurrentPage(newPage + 1) }}
                                        onChangeRowsPerPage={(event) => getEngineTypes({ ...filter, page: 1, per_page: event.target.value, sort_by: sortInfo?.sort_by, sort: sortInfo?.sort }, 'pageLoader')}
                                    />
                                </Paper>
                            </div>}
                    </div>
                    {addEditEngineTypes.modal ?
                        <AddEditEngineTypes
                            addEditEngineTypes={addEditEngineTypes}
                            engineTypesInfo={engineTypesInfo}
                            toggleModalFn={() => setAddEditEngineTypes({ modal: false, engineType: [] })}
                            getResponseBack={() => getEngineTypes({ ...filter, page: engineTypesInfo?.pagination?.page, per_page: engineTypesInfo?.pagination?.per_page }, 'pageLoader')}
                            modeType={addEditEngineTypes?.type}
                        /> : null
                    }
                    <DeletePopUp
                        confirmColor={getConfirmColor()}
                        confirmText={getConfirmText()}
                        modal={getModal()}
                        title={getTitle()}
                        content={getContent()}
                        toggleModalFn={toggleModalFn}
                        deleteRecordFn={getDeleteRecordFn()}
                        circularloader={circularLoader}
                    />
                </Paper> :<NoAccess /> 
            }
            {linkingEngine.modal &&
                <LinkingPopup
                    title="Engine Type"
                    circularloader={circularLoader}
                    linkUnlink={(type, ids) => linkUnlink(type, ids)}
                    placeholder='Search By Engine Type ...'
                    description='No Engine Types is available to link'
                    url={`config-data/aircraft-type/?linked_aircraft_types_name=engine_type&id=${params?.id}&action=unlink`}
                    data={engineTypesInfo}
                    toggleModalFn={() => setLinkingEngine({ modal: false, data: null })}
                />
            }
            {isLoading ? <PageLoader /> : null}
        </section>
    )
}
export default withRouter(EngineTypes);